module.exports = __webpack_public_path__ + "static/img/customerService.968742a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/customerService.png
// module id = Y30w
// module chunks = 1